import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  
  return getRequest(`userEvent/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  return getRequest(`userEvent/edit/${id}`)
}

export async function save(values) {
  return postRequest(`userEvent/save`, values)
}

export function remove(values) {
  return postRequest(`userEvent/delete`, values)
}
